// src/app/auth/jwt.interceptor.ts
import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import 'rxjs/add/operator/do';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private inj: Injector
  ) {}
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this.inj.get(AuthService);
    return next.handle(request).do((event: HttpEvent<any>) => {
      // loader.hide(); 
      if (event instanceof HttpResponse) {
        if(event.url.indexOf('login') > -1 || event.url.indexOf('validatesession') > -1) {
          if(event.body.error == 0) {
            let token = event.body.responseObj.token;
            localStorage.setItem('token', token);
            // delete event.body.responseObj.token;
            // let user = event.body.responseObj;
          }
        }
        // return event;
          
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          auth.logout();
          // localStorage.removeItem('token');
          // localStorage.clear();
          // this.router.navigate(['/login']);
            // return event;
            // redirect to the login route
            // or show a modal
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.interceptor.ts